var render = function render(){var _vm=this,_c=_vm._self._c;return _c('w-tooltip',{attrs:{"right":"","size":"small"},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('w-checkbox',_vm._b({attrs:{"disabled":true,"hide-details":"auto"}},'w-checkbox',_vm.$attrs,false))]},proxy:true}])},[_vm._t("label")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }